import React, { FC } from "react";
import type { AutomationDigitalBoardingProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const AutomationDigitalBoarding: FC<AutomationDigitalBoardingProps> = ({
  subtitle,
  content,
  networkOfSpecialists,
  cover,
}) => {
  return (
    <section className="automationDigitalBoarding">
      <div className="wrapper">
        <div className="automationDigitalBoarding--subtitle">{subtitle}</div>
        <TextCols content={content} maxTitleWidth={732} />
        <div className="automationDigitalBoarding--networkOfSpecialists">
          {networkOfSpecialists?.title && (
            <ContentManager
              content={networkOfSpecialists.title}
              className="automationDigitalBoarding--networkOfSpecialists-title"
            />
          )}
          {networkOfSpecialists?.description && (
            <ContentManager
              content={networkOfSpecialists.description}
              className="automationDigitalBoarding--networkOfSpecialists-description"
            />
          )}
        </div>
      </div>
      <div className="wrapper wrapper_lg">
        {cover?.file?.url && (
          <Image
            className="automationDigitalBoarding--cover"
            src={cover as any}
            alt={cover.title}
          />
        )}
      </div>
    </section>
  );
};
